module.exports = __webpack_public_path__ + "static_portal/img/playback_rate.deff61df.jpg";